import { Outlet } from "react-router";

export default function Tilsynserklaering() {
  return (
    <div className="container-xxl mt-3 mb-7">
      <Outlet />
    </div>
  );
}
